import {GetProviderNamesParams} from 'domain/usecases/private/booking-flow/health-V1/get-health-provider-names';
import {makeGetHealthProviderNames} from 'main/factories/usecases/private/booking-flow/remote-health-booking-v1/get-health-provider-names-factory';

async function getHealthProvidersName(params: GetProviderNamesParams) {
	const providers = await makeGetHealthProviderNames().get(params);

	return providers;
}

export {getHealthProvidersName};
